<template>
  <CHeader
    data-aos-easing="linear"
    data-aos-duration="1500"
    id="el"
    class="navbars"
  >
    <CHeaderBrand class="mx-auto" to="/">
      <img
        src="../assets/img/Logo.png"
        height="38"
        class="m-1"
      />
    </CHeaderBrand>

    <CDropdown color="light" class="m-2 d-sm-flex d-lg-none" :caret="false">
      <template #toggler-content>
        <CIcon name="cil-justify-center" />
      </template>
      
      <CDropdownItem to="/"> {{ $t('homepage') }} </CDropdownItem>
      <CDropdownItem to="MatchingOpponent"> {{ $t('scoreBoard') }} </CDropdownItem>
      <CDropdownItem to="ViewParticipant"> {{ $t('viewParticipant') }} </CDropdownItem>
      <CDropdownItem to="Gallery"> {{ $t('gallery') }} </CDropdownItem>
      <CDropdownItem to="Announcement"> {{ $t('Announcement') }} </CDropdownItem>
      <CDropdownItem href="ViewTeams"> {{ $t('forClubsAndOrganization') }} </CDropdownItem>
      <CDropdownItem href="LoginAccount"> {{ $t('login') }} </CDropdownItem>
      <CDropdownItem href="CreateAccount"> {{ $t('signUp') }} </CDropdownItem>
      <CDropdownItem href="">  <a href="#" @click.prevent="changeLanguage('ms')" title="Malay" class="mr-2">BM</a> </CDropdownItem>
      <CDropdownItem href="">   <a href="#" @click.prevent="changeLanguage('en')" title="English" class="ml-2">EN</a> </CDropdownItem>
    </CDropdown>

    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink to="/"> {{ $t('homepage') }} </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-1">
        <CHeaderNavLink to="MatchingOpponent"> {{ $t('scoreBoard') }} </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-1">
        <CHeaderNavLink to="ViewParticipant"> {{ $t('viewParticipant') }} </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-1">
        <CHeaderNavLink to="Gallery"> {{ $t('gallery') }} </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-1">
        <CHeaderNavLink to="Announcement"> {{ $t('Announcement') }} </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-1">
        <CHeaderNavLink to="ViewTeams"> {{ $t('forClubsAndOrganization') }} </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem>
        <CHeaderNavLink>
          <CButton class="button-logins" @click="GoToLogin()"><span class="ml-2 mr-2"> {{ $t('login') }} </span></CButton>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem>
        <CHeaderNavLink>
          <CButton class="button-Explore text-white" @click="GoToSignUp()"><span class="ml-2 mr-2"> {{ $t('signUp') }} </span></CButton>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
        <CHeaderNavLink style="color: #fff; font-family: 'Montserrat', sans-serif; font-weight: bold; font-size: 15px;">
          <a href="#" @click.prevent="changeLanguage('ms')" title="Malay" class="mr-2">BM</a>
          |
          <a href="#" @click.prevent="changeLanguage('en')" title="English" class="ml-2">EN</a>
        </CHeaderNavLink>
      </CHeaderNavItem>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";

export default {
  name: "TheHeader",
  components: {
    TheHeaderDropdownAccnt,
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    GoToLogin()
    {
      this.$router.push("LoginAccount");
    },
    GoToSignUp()
    {
      this.$router.push("CreateAccount");
    }
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>
